import * as Storage from "aws-amplify/storage";
import * as React from "react";
import {
  Document,
  Page
} from "react-pdf/dist/esm/entry.webpack";

interface S3PDFProps {
  s3Key: string;
}
export const S3PDF: React.ReactFCWithChildren<S3PDFProps> = ({ s3Key }) => {
  const [ numPages, setNumPages ] = React.useState(1);
  const [ signedUrl, setSignedUrl ] = React.useState<string>();

  const getSignedUrl = React.useCallback(async (s3Key: string) => {
    const url = await Storage.getUrl({ path: `public/${s3Key}` });

    setSignedUrl(url.url.toString());
  }, []);

  React.useEffect(() => {
    if (s3Key) {
      getSignedUrl(s3Key);
    }
  }, [ getSignedUrl, s3Key ]);

  return (
    <>
      {!!signedUrl &&
  (
    <Document
      file={signedUrl}
      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
    >

      {!!numPages && Array(numPages).fill(0).map((_empty, pageNumber) => {
        return (
          <Page
            className="pdf-page-wrapper"
            key={`document-page-${pageNumber}`}
            pageNumber={pageNumber + 1}
          />
        );
      })}
    </Document>
  )}
    </>
  );
};
